import { defineMessages } from 'react-intl'

import { EStatus } from './constants'

export const statusMessages = defineMessages({
  [EStatus.Active]: {
    id: 'fares.status.active',
    defaultMessage: 'Active'
  },
  [EStatus.Inactive]: {
    id: 'fares.status.inactive',
    defaultMessage: 'Inactive'
  }
})
